<template>
  <div class="page flex-col">
    <div class="section_1 flex-col scaler flex-justify-center flex-align-center">
      <div class="group_1 flex-row justify-between">
        <div class="box_1 flex-col" @click="ClickMetaHuman"
          :class="{ 'scale-up': MetaHumanShow && MetaHumanClicked, 'scale-down': !MetaHumanShow && MetaHumanClicked }"
          style="overflow: hidden;" ref="MetaHuman">
          <img style="width:600px;height:900px;margin-left:-200px;margin-top:-60px;position:initial;"
            referrerpolicy="no-referrer" src="./assets/img/shuziren.png" />
        </div>
        <div class="box_2 flex-col justify-between">
          <span class="text_1">Welcome{{ nickname ? ':' + nickname + '同学' : '' }}
          </span>
          <div class="text-wrapper_1 flex-row justify-between">
            <span class="text_2">欢迎使用AI面试官</span>
            <span class="text_3">，即刻上传您的简历</span>
          </div>
        </div>
      </div>
      <div class="group_2 flex-row justify-between"
        :style="{ 'transition': 'margin-left 1s', 'margin-left': MetaHumanShow ? '2268px' : '2100px' }">
        <div class="group_3 flex-col">
          <div class="text-wrapper_2 flex-row"><span class="text_4">个人档案</span></div>
          <div class="image-wrapper_1 flex-row">
            <img class="image_1" referrerpolicy="no-referrer" :src="avatar" />
            <!--             <img class="image_1" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGbcf9180e8816925152134cd8a374a7de.png" /> -->
          </div>
          <template v-if="account != ''">
            <div class="text-wrapper_3 flex-row"><span class="text_5">{{ account }}</span></div>
          </template>
          <template v-else>
            <router-link to="/store/entry">
              <div class="text-wrapper_3 flex-row"><span class="text_5">去登录或注册</span></div>
            </router-link>
          </template>
          <template v-if="account != ''">
            <div class="text-wrapper_3 flex-row justify-center" style="margin-top:-60px;">
              <span class="text_5"
                style="font-size:medium;-webkit-text-fill-color:rgba(101, 101, 135, 1);cursor:pointer;"
                @click="gotomianshilishi()">
                面试记录
                <img style="position:relative;top:3px;" referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNGe9967409133ab308afb2507e40b3f901.png" />
              </span>
              <span class="text_5"
                style="font-size:medium;-webkit-text-fill-color:rgba(101, 101, 135, 1);cursor:pointer;"
                @click="dialogVisible = true">
                个人资料
                <img style="position:relative;top:3px;" referrerpolicy="no-referrer"
                  src="./assets/img/FigmaDDSSlicePNGfb08c4aa5a39abd981d1f78225a5b325.png" />
              </span>
            </div>
          </template>
        </div>
        <div class="group_4 flex-col justify-between">
          <div class="group_5 flex-col">
            <div class="section_2 flex-col">
              <el-upload :class="{ 'UploadedColor': CvUploaded }" style="width:100%;height:100%;" drag
                accept=".pdf,.doc,.docx,.txt,image/*" :auto-upload="false" :on-change="UploadCvFunc"
                :on-remove="RemoveCvFunc" action="#" :limit="1" ref="CvUpload" :disabled="false"
                :show-file-list="false">
                <div v-if="CvUploaded">
                  <div class="image-wrapper_2_ flex-row" @click="RemoveCvFunc()" @click.stop>
                    <img class="label_1_" referrerpolicy="no-referrer"
                      src="./assets/img/FigmaDDSSlicePNG2782f6d9ac2f655cfbb22e2b6cc09020.png" />
                  </div>
                  <div class="box_1_ flex-row">
                    <div class="image-text_1_ flex-col justify-between">
                      <img class="image_2_" referrerpolicy="no-referrer"
                        src="./assets/img/FigmaDDSSlicePNGbb300d9596eaabffb04f0c6eea0d37e3.png" />
                      <span class="text-group_1_">{{ uploadedCvFileName }}</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="image-text_1 flex-col justify-between">
                    <img class="image_2" referrerpolicy="no-referrer"
                      src="./assets/img/FigmaDDSSlicePNGb08c124320a32285f623dfb4adb6d243.png" />
                    <span class="text-group_1">
                      拖拽或点击上传简历
                      <br />
                      支持pdf、word、txt、所有图片格式
                    </span>
                  </div>
                  <div class="box_3 flex-row justify-between">
                    <span class="text_6">上传简历</span>
                    <div class="group_6 flex-col"></div>
                  </div>
                </div>
              </el-upload>
            </div>
          </div>
          <div class="group_7">
            <div class="flex-row">
              <span class="text_7" style="font-weight:bold;">选择本场面试时长</span>
              <div class="custom-dropdown-container">
                <div @click="toggleDropdown" class="custom-dropdown-button">
                  <span class="color-text" style="font-size:1.2vw; font-weight:bold;">{{ duration || '请选择' }}</span>
                  <img src="./assets/img/arrow.png" class="custom-arrow-icon"
                    :class="{ 'arrow_rotate_up': dropdownVisible }">
                </div>
                <div v-show="dropdownVisible" class="custom-dropdown">
                  <div @click="selectOption(30)" class="custom-dropdown-item">30分钟</div>
                  <div @click="selectOption(15)" class="custom-dropdown-item">15分钟</div>
                </div>
              </div>
            </div>
            <div class="language-selection flex-row">
              <span class="text_7" style="font-weight:bold; margin-left: 24px;">选择面试语言</span>
              <div class="custom-dropdown-container">
                <div @click="toggleLanguageDropdown" class="custom-dropdown-button">
                  <span class="color-text" style="font-size:1.2vw; font-weight:bold;">{{ language || '请选择' }}</span>
                  <img src="./assets/img/arrow.png" class="custom-arrow-icon"
                    :class="{ 'arrow_rotate_up': languageDropdownVisible }">
                </div>
                <div v-show="languageDropdownVisible" class="custom-dropdown">
                  <div @click="selectLanguage(1)" class="custom-dropdown-item">中文</div>
                  <div @click="selectLanguage(2)" class="custom-dropdown-item">英语</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="group_9 flex-col justify-between">
          <div class="group_10 flex-col">
            <div class="box_4 flex-col">
              <el-upload :class="{ 'UploadedColor': JdUploaded }" style="width:100%;height:100%;" drag
                accept=".pdf,.doc,.docx,.txt,image/*" :auto-upload="false" :on-change="UploadJdFunc"
                :on-remove="RemoveJdFunc" action="#" :limit="1" ref="JdUpload" :disabled="false"
                :show-file-list="false">
                <div v-if="JdUploaded">
                  <div class="image-wrapper_3_ flex-row" @click="RemoveJdFunc()" style="z-index: 1;" @click.stop>
                    <img class="label_2_" referrerpolicy="no-referrer"
                      src="./assets/img/FigmaDDSSlicePNG2782f6d9ac2f655cfbb22e2b6cc09020.png" />
                  </div>
                  <div class="group_6_ flex-row">
                    <div class="image-text_2_ flex-col justify-between">
                      <img class="image_3_" referrerpolicy="no-referrer"
                        src="./assets/img/FigmaDDSSlicePNG47c30b7fe3694047b5a6de10fbfe0144.png" />
                      <span class="text-group_2_">{{ uploadedJdFileName }}</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="image-text_2 flex-col justify-between">
                    <img class="image_3" referrerpolicy="no-referrer"
                      src="./assets/img/FigmaDDSSlicePNGb08c124320a32285f623dfb4adb6d243.png" />
                    <span class="text-group_2">
                      拖拽或点击上传岗位要求
                      <br />
                      支持pdf、word、txt、所有图片格式
                    </span>
                  </div>
                  <div class="box_5">
                    <div class="row-container flex-row justify-between">
                      <span class="text_9">上传岗位JD</span>
                      <div class="section_3 flex-col"></div>
                    </div>
                    <div class="row-container flex-row justify-between" @click.stop>
                      <div class="section_3 flex-col"></div>
                      <span class="text_11">AI自动生成岗位要求</span>
                    </div>
                  </div>
                </div>
              </el-upload>
            </div>
          </div>
          <button class="text-wrapper_5 flex-row" :class="{ 'ready-go': readyGo }" :disabled="!readyGo"
            @click="handleClickReadyGo()">
            <div>
              <span class="text_10" :style="{ 'color': readyGo ? 'white' : 'rgba(0, 0, 0, 0.25)' }">准备好了 GO!</span>
            </div>
          </button>
        </div>
      </div>
    </div>
    <!-- 弹窗容器 -->
    <div class="modal-container" v-if="showModal" @click.self="handleClose">
      <!-- 遮罩层 -->
      <div class="modal-mask"></div>

      <!-- 弹窗内容 -->
      <div class="modal-content" @click.stop>
        <div class="header">
          <div class="title" v-if="!showRequirements">请选择岗位名称</div>
          <div class="title" v-if="showRequirements">岗位要求</div>
          <div class="close-btn" @click="handleClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="content">
          <div class="sidebar" v-if="!showRequirements">
            <div v-for="(item, index) in categories" :key="index" class="sidebar-item"
              :class="{ active: currentCategory === item }" @click="handleCategoryClick(item)">
              {{ item }}
            </div>
          </div>
          <div class="main-content">
            <div class="category" v-if="!showRequirements">
              <div class="job-list">
                <div v-for="(job, index) in filteredJobs" :key="index" class="job-item"
                  :class="{ selected: selectedJobs.includes(job) }" @click="handleJobClick(job)">
                  {{ job }}
                  <span v-if="selectedJobs.includes(job)" class="close" @click.stop="handleJobClose(job)">
                    ×
                  </span>
                </div>
              </div>
            </div>
            <div class="generated-requirements" v-if="showRequirements">
              <h3>工作内容：</h3>
              <ul>
                <li v-for="(item, index) in jobContent" :key="index">{{ item }}</li>
              </ul>
              <h3>岗位要求：</h3>
              <ul>
                <li v-for="(item, index) in jobRequirements" :key="index">{{ item }}</li>
              </ul>
            </div>
            <div class="buttons">
              <button class="btn btn-outline" @click="handleBack" v-if="showRequirements">上一步</button>
              <button class="btn btn-primarys" @click="generateRequirements">AI生成岗位要求</button>
              <button class="btn btn-primarys" @click="handleManual">手动输入岗位</button>
              <button class="btn btn-primary" @click="handleConfirm" v-if="showRequirements">确定</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dialogVisible" style="backdrop-filter:blur(5px);position:absolute;width:100%;height:100%;"></div>
    <div v-if="dialogVisible" style="position:absolute;bottom:10px;right:10px;cursor:pointer;z-index:2002;"
      @click="$consoleLog('log out.')">
      <div class="image-text_2_1 flex-row justify-between">
        <span class="text-group_3_1">退出登陆</span>
        <img class="thumbnail_1_1" referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNG707dd8d6c2d9efd78983e452e84c7ba9.png" />
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="true" :show-close="false">
      <router-view @close-dialog="dialogVisible = false" style="margin-left:24px;margin-top:-18px;"></router-view>
    </el-dialog>
    <div v-show="waitingForPrompt" class="flex-col align-center"
      style="position:fixed;left:35vw;top:40vh;width:30vw;height:20vh;font-size:medium;text-align:center;z-index:2;">
      <div class="spinner"></div>
      <div style="margin-top:20px;color:gray;">正在为您准备面试中，请稍等...</div>
    </div>
  </div>
</template>

<script>
import { test_uesrinfo, getUserInfo } from '@/api/user'
import { generatePrompt } from '@/api/upload'
import dropdownMethods from './methods'
import { mapState } from 'vuex'
import { setToken, removeToken, getToken } from '@/store/local/auth'

export default {
  computed: {
    ...mapState('interviewState', ['jd', 'cv']),
        filteredJobs() {
      return this.jobs[this.currentCategory];
    },
    readyGo() {
      return this.duration != '' && this.language != '' && this.CvUploaded && this.JdUploaded && !this.waitingForPrompt
    },
    uploadedJdFileName() {
      return this.jd ? this.jd.name : ''
    },
    uploadedCvFileName() {
      return this.cv ? this.cv.name : ''
    },
    JdUploaded() {
      return this.jd !== null
    },
    CvUploaded() {
      return this.cv !== null
    },

  },
  data() {
    return {
      showModal: true,
      categories: [
        '技术',
        '产品/运营',
        '设计',
        '市场',
        '咨询/法律/翻译',
        '人事/财务/行政',
        '销售'
      ],
      currentCategory: '技术',
      jobs: {
        '技术': [
          '前端开发', '后端开发', '移动开发', '测试', '运维/技术支持',
          '数据', '人工智能', '硬件开发', '高端技术岗位', '其他技术岗位'
        ],
        '产品/运营': [
          '产品经理', 'AI产品经理', '产品运营', '社群运营',
          '新媒体运营', '用户研究', '其他产品/运营'
        ],
        '设计': ['视觉设计', '交互设计', '其他设计岗位'],
        '市场': ['市场', '公关媒介', '广告', '其他市场岗位'],
        '咨询/法律/翻译': ['咨询', '律师', '翻译', '其他咨询/法律岗位'],
        '人事/财务/行政': [
          '人力资源', '行政', '财务', '法务', '审计', '税务',
          '其他人亊行政岗位'
        ],
        '销售': ['商务销售', '销售管理', '其他销售岗位']

      },
      selectedJobs: [],
      showRequirements: false,
      jobContent: [
        '负责产品的整体规划、设计、推进及优化，深入了解用户需求，制定产品策略，并推动产品迭代升级。',
        '与技术团队紧密合作，完成产品技术方案的制定、评审和实施，确保产品开发的顺利进行。',
        '负责产品市场分析和竞品研究，为产品定位和发展提供数据支持。',
        '持续跟踪产品运营数据，分析用户反馈，优化产品功能和用户体验。',
        '撰写产品需求文档、产品说明书等相关文档，确保产品开发的顺利进行。'
      ],
      jobRequirements: [
        '本科及以上学历，计算机、电子商务、市场营销等相关专业优先考虑。',
        '熟练掌握产品管理工具，具备良好的项目管理能力。',
        '对互联网行业趋势有深刻理解，具备敏锐的市场洞察力和创新思维。',
        '优秀的沟通协调能力和团队合作精神，能够承受一定的工作压力。',
        '具备良好的数据分析能力，能够运用数据推动产品决策。'
      ],
      avatar: require('./assets/img/FigmaDDSSlicePNGbcf9180e8816925152134cd8a374a7de.png'),
      dialogVisible: false,
      dropdownVisible: false,
      languageDropdownVisible: false,
      MetaHumanShow: false,
      MetaHumanClicked: false,
      MetaHumanClickable: true,
      duration: '',
      language: '',
      waitingForPrompt: false,
      account: '',
      nickname: ''
    };
  },
  mounted() {
    this.checkLoginStatus()
    this.loginInfo()
    this.checkLocalFiles()
    this.getInfo()
    setTimeout(() => {
      this.$refs.MetaHuman.click()
    }, 2000)
    // 添加点击外部关闭下拉菜单的事件监听
    document.addEventListener('click', this.handleDocumentClick)
    // 检查本地存储中的文件

  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('click', this.handleDocumentClick)
  },
  methods: {
    ...dropdownMethods,
    // 打开弹窗
    openModal() {
      this.showModal = true;
    },
    // 关闭弹窗
    handleClose() {
      this.showModal = false;
      // 重置状态
      this.selectedJobs = [];
      this.showRequirements = false;
      this.currentCategory = '技术';
    },
    handleCategoryClick(category) {
      this.currentCategory = category;
    },
    handleJobClick(job) {
      if (this.selectedJobs.includes(job)) {
        this.selectedJobs = this.selectedJobs.filter(item => item !== job);
      } else {
        this.selectedJobs.push(job);
      }
    },
    handleJobClose(job) {
      this.selectedJobs = this.selectedJobs.filter(item => item !== job);
    },
    generateRequirements() {
      if (this.selectedJobs.length > 0) {
        this.showRequirements = true;
      } else {
        alert('请先选择一个岗位');
      }
    },
    handleManual() {
      alert('手动输入岗位功能');
    },
    handleBack() {
      this.showRequirements = false;
    },
    handleConfirm() {
      alert('确认选择的岗位: ' + this.selectedJobs.join(','));
      this.showModal = false;
      // 这里可以添加回调函数，将选择的岗位传递给父组件
    },
    // 处理点击文档的事件
    handleDocumentClick(e) {
      const dropdown = this.$el.querySelector('.custom-dropdown-container');
      if (dropdown && !dropdown.contains(e.target)) {
        this.closeDropdown();
      }
    },
    async getInfo() {
      let res = await getUserInfo();
      if (res.data.code == 1) {
        this.avatar = res.data.data.avatar;
        console.log('头像获取成功:', this.avatar);

      } else if (res.data.code == -1) {
        this.$message({
          message: '登录状态失效将在2S后重新登录',
          type: 'error',
        });

        await new Promise((resolve) => setTimeout(resolve, 3000));
        await this.$store.dispatch('user/logout');
      }
    },
    // 检查本地存储中的文件
    checkLocalFiles() {
      /*       if (this.jd) {
              this.$refs.JdUpload.uploadFiles = [{ name: this.jd.name, raw: this.jd }];
            }
            if (this.cv) {
              this.$refs.CvUpload.uploadFiles = [{ name: this.cv.name, raw: this.cv }];
            } */
      // 检查 localStorage 中的 CV
      const cv = localStorage.getItem('cv');
      if (cv) {
        const cvFile = JSON.parse(cv);
        this.$refs.CvUpload.uploadFiles = [{ name: cvFile.name, raw: cvFile }];
        this.CvUploaded = true;
      }

      // 检查 localStorage 中的 JD
      const jd = localStorage.getItem('jd');
      if (jd) {
        const jdFile = JSON.parse(jd);
        this.$refs.JdUpload.uploadFiles = [{ name: jdFile.name, raw: jdFile }];
        this.JdUploaded = true;
      }
    },
    // 检查登录状态
    checkLoginStatus() {
      if (localStorage.getItem('userInfo')) {
        // 有用户信息，检查token是否有效
        if (!getToken()) {
          // token不存在，清除用户信息
          localStorage.removeItem('userInfo')
          this.$message.warning('您的登录已过期，请重新登录')
          this.$router.push('/store/entry')
          return
        }

        // token存在，调用API验证token是否有效
        test_uesrinfo().then(response => {
          if (response.data.code !== 1) {
            // token无效
            removeToken()
            localStorage.removeItem('userInfo')
            this.$message.warning('您的登录状态已失效，请重新登录')
            this.$router.push('/store/entry')
          }
        }).catch(() => {
          // API调用失败
          removeToken()
          localStorage.removeItem('userInfo')
          this.$message.warning('无法验证您的登录状态，请重新登录')
          this.$router.push('/store/entry')
        })
      }
    },
    loginInfo() {
      if (!getToken()) localStorage.removeItem('userInfo')
      if (localStorage.getItem('userInfo')) {
        const info = JSON.parse(localStorage.getItem('userInfo'))
        this.account = info.account
        this.nickname = info.nickname
      }
    },
    UploadCvFunc(file) {
      this.$store.commit('interviewState/SET_CV', file.raw)
    },
    RemoveCvFunc() {
      localStorage.removeItem('cv')
      // 更新组件的状态
      this.CvUploaded = false
      this.$store.commit('interviewState/SET_CV', null)
    },
    UploadJdFunc(file) {
      this.$store.commit('interviewState/SET_JD', file.raw)
    },
    RemoveJdFunc() {
      localStorage.removeItem('jd')
      // 更新组件的状态
      this.JdUploaded = false
      this.$store.commit('interviewState/SET_JD', null)
    },
    ClickMetaHuman() {
      if (!this.MetaHumanClickable) return
      this.MetaHumanShow = !this.MetaHumanShow
      this.MetaHumanClicked = true
      this.MetaHumanClickable = false
      setTimeout(() => { this.MetaHumanClickable = true }, 1000)
    },
    testApi() {
      test_uesrinfo().then(response => {
        this.$message(response.data.data.nickname)
      })
    },
    gotomianshilishi() {
      this.$router.push('/interview_mianshilishi')
    },
    handleClickReadyGo() {
      this.$router.push('/store/select_metahuman')
    }
  }
};
</script>

<style scoped lang="css" src="./assets/index.css" />
<style scoped>
@media (max-width: 1600px) {
  .scaler {
    transform-origin: top left;
    transform: scale(0.75);
  }
}

@media (min-width: 1600px) {
  .scaler {
    transform-origin: top left;
    transform: scale(0.87);
    padding-top: 100px;
  }
}

::v-deep .el-upload {
  width: 100%;
  height: 100%;
}

::v-deep .el-upload-dragger {
  width: 100%;
  height: 100%;
  background: none;
  border: none;
}

@keyframes scaleUp {
  0% {
    transform: scale(1);
    width: 166px;
    height: 166px;
    background: none;
    box-shadow: none;
    animation-timing-function: ease-in;
  }

  33% {
    animation-timing-function: ease-out;
  }

  100% {
    transform: scale(2.1);
    width: 332px;
    height: 498px;
    padding-left: 100px;
    padding-top: 81px;
    margin-left: -198px;
    margin-top: 78px;
    background: none;
    box-shadow: none;
  }
}

.scale-up {
  animation: scaleUp 0.75s forwards;
}

@keyframes scaleDown {
  0% {
    transform: scale(2.1);
    width: 332px;
    height: 498px;
    padding-left: 100px;
    padding-top: 81px;
    margin-left: -198px;
    margin-top: 78px;
    background: none;
    box-shadow: none;
    animation-timing-function: ease-out;
  }

  67% {
    animation-timing-function: ease-in;
  }

  100% {
    transform: scale(1);
    width: 166px;
    height: 166px;
    padding-left: 0px;
    padding-top: 0px;
    margin-left: 0px;
    margin-top: 0px;
    background: none;
    box-shadow: none;
    animation-timing-function: ease-in;
  }

  100% {
    background: linear-gradient(325deg, rgba(126, 180, 235, 0.1) 0, rgba(177, 110, 249, 0.1) 100%);
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }
}

.scale-down {
  animation: scaleDown 0.75s forwards;
}

.color-text {
  background-image: linear-gradient(0deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.color-background {
  background-image: linear-gradient(180deg,
      rgba(126, 180, 235, 0.15) 0,
      rgba(177, 110, 249, 0.15) 100%);
}

.ready-go {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
}

.arrow_rotate_up {
  transform: rotate(180deg)
}

::v-deep .el-dialog {
  width: 400px;
  height: 450px;
  overflow: hidden;
  top: -50px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.75);
}

::v-deep .el-dialog__body {
  padding: 0px;
}

.spinner {
  border: 5px solid rgba(126, 180, 235, 1);
  border-radius: 50%;
  border-top: 5px solid rgba(177, 110, 249, 1);
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.custom-dropdown-container {
  position: relative;
  display: inline-block;
  margin-top: 0.6vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-dropdown-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1vw;
  box-shadow: 0 0.5vh 10px 0 rgba(0, 0, 0, 0.1);
  padding: 0.30vw;
  background: linear-gradient(180deg, rgba(126, 180, 235, 0.15) 0%, rgba(177, 110, 249, 0.15) 100%);
  cursor: pointer;
  border: none;
  min-width: 120px;
}

.custom-dropdown {
  position: absolute;
  top: calc(100% + -36px);
  left: 0;
  min-width: 100%;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(177, 110, 249, 0.3);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  overflow: hidden;
  padding: 5px 0;
}

.custom-dropdown-item {
  padding: 10px 16px;
  cursor: pointer;
  text-align: center;
  background-image: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  position: relative;
  z-index: 2;
  font-weight: bold;
  font-size: 16px;
}

.custom-dropdown-item:hover {
  background-color: rgba(177, 110, 249, 0.15);
}

.el-icon-arrow-down {
  margin-left: 10px;
  transition: transform 0.3s ease;
}

.custom-arrow-icon {
  width: 16px;
  height: 16px;
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.arrow_rotate_up {
  transform: rotate(180deg);
}

.group_3 {
  border: 1px solid #7EB4EB;
}

.group_5 .group_7 .group_10 {
  border: 1px solid #B16EF9;
}
/* 触发按钮样式 */
.open-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #7e6ef8;
  color: white;
  border: none;
}

.open-btn:hover {
  background-color: #6a5ee0;
}

/* 弹窗样式 */
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
  
}

.modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
}

.modal-content {
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  width: 80%;
  max-width: 740px;
  position: relative;
  z-index: 1;
  animation: modalFadeIn 0.3s;
}

@keyframes modalFadeIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.content {
  display: flex;
  height: calc(100vh - 180px);
}

.sidebar {
  width: 200px;
  background-color: #f9fbfe;
  padding: 20px 0;
}

.sidebar-item {
  padding: 12px 20px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
}

.sidebar-item:hover {
  color: #4f6dff;
}

.sidebar-item.active {
  color: #4f6dff;
  font-weight: 500;
  background-color: #e0e6ff;
}

.main-content {
  flex: 1;
  padding: 20px;
  background: linear-gradient(180deg, rgba(177, 110, 249, 0.5) 0%, rgba(126, 180, 235, 0.5) 100%);
  opacity: 0.8;
  position: relative;
  z-index: 0;
  overflow-y: auto;
  height: 100%;
}

.category {
  margin-bottom: 20px;
}

.category-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.job-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.job-item {
  padding: 12px 16px;
  background-color: transparent;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  color: #656587;
  font-family: Afacad;
  font-style: normal;
  font-weight: 500;
}

.job-item.selected {
  border-radius: 21.6px;
  background: linear-gradient(90deg, rgba(126, 180, 235, 0.40) 0%, rgba(177, 110, 249, 0.40) 100%), linear-gradient(321deg, rgba(255, 255, 255, 0.00) 2.06%, rgba(255, 255, 255, 0.40) 99.08%);
  box-shadow: 3.6px 3.6px 3.6px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(13.5px);
}

.job-item.selected .close {
  display: inline-block;
}

.close {
  display: none;
  margin-left: 6px;
  color: #a8b3d9;
  font-weight: normal;
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
}

.btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #7e6ef8;
  color: white;
  border: none;
}

.btn-primarys {
  border-radius: 21.6px;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%), linear-gradient(321deg, rgba(255, 255, 255, 0.00) 2.06%, rgba(255, 255, 255, 0.40) 99.08%);
  border: 1px solid #7e6ef8;
  backdrop-filter: blur(13.5px);
  color: #F0FBFF;
  text-align: center;
  font-family: Afacad;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.btn-primary:hover {
  background-color: #6a5ee0;
}

.btn-outline {
  background-color: transparent;
  color: #7e6ef8;
  border: 1px solid #7e6ef8;
}

.btn-outline:hover {
  background-color: #f0f3ff;
}

.generated-requirements {
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 20px;
  margin-top: 20px;
}

.generated-requirements h3 {
  margin-bottom: 15px;
  color: #4f6dff;
}

.generated-requirements ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.generated-requirements li {
  margin-bottom: 10px;
}
</style>